import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  // Laptops
  {
    _id: uuid(),
    category: "Laptop",
    name: "HP Spectre x360",
    specification: "15.6-inch, Intel i7, 16GB RAM, 512GB SSD",
    price: 12999,
    deliveryInDays: 5,
    url: "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08347245.png",
    rating: 4,
    brand:"HP"
  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Dell XPS 13",
    specification: "13.3-inch, Intel i5, 8GB RAM, 256GB SSD",
    price: 1000,
    deliveryInDays: 3,
    url: "https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/notebooks/xps-notebooks/xps-13-9315/media-gallery/notebook-xps-9315-nt-blue-gallery-3.psd?fmt=png-alpha&pscan=auto&scl=1&hei=402&wid=575&qlt=100,1&resMode=sharp2&size=575,402&chrss=full",
    rating: 4.5,
    brand:"Dell"

  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "MacBook Pro",
    specification: "16-inch, Apple M1, 16GB RAM, 1TB SSD",
    price: 23999,
    deliveryInDays: 7,
    url: "https://store.storeimages.cdn-apple.com/4668/as-images.apple.com/is/mbp-spacegray-select-202206?wid=904&hei=840&fmt=jpeg&qlt=90&.v=1664497359481",
    rating: 5,
    brand:"Apple"
  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Lenovo ThinkPad X1 Carbon",
    specification: "14-inch, Intel i7, 16GB RAM, 512GB SSD",
    price: 14999,
    deliveryInDays: 4,
    url: "https://www.stepstrade.com/wp-content/uploads/2021/03/lenovo-laptop-thinkpad-x1-carbon-gen8-subseries-hero.png",
    rating: 4.5,
    brand:"Lenovo"

  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Asus ROG Zephyrus G14",
    specification: "14-inch, AMD Ryzen 9, 32GB RAM, 1TB SSD",
    price: 17999,
    deliveryInDays: 6,
    url: "https://m.media-amazon.com/images/I/81m-xYfxznL.jpg",
    rating: 5,
    brand:"Asus"

  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Acer Swift 3",
    specification: "14-inch, Intel i5, 8GB RAM, 256GB SSD",
    price: 6999,
    deliveryInDays: 2,
    url: "https://m.media-amazon.com/images/I/81nN5u1MEuL.jpg",
    rating: 3.5,
  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Dell Inspiron 15",
    specification: "15.6-inch, AMD Ryzen 7, 16GB RAM, 1TB SSD",
    price: 5000,
    deliveryInDays: 4,
    url: "https://images-cdn.ubuy.co.in/633aae8db52ac20d0b37956e-dell-inspiron-15-3000-laptop-2021.jpg",
    rating: 2.5,
    brand:"Dell"

  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Microsoft Surface Laptop 4",
    specification: "13.5-inch, Intel i7, 16GB RAM, 512GB SSD",
    price: 11999,
    deliveryInDays: 3,
    url: "https://i.gadgets360cdn.com/products/large/Surface-Laptop-4-15-DB-954x800-1618386346.jpg",
    rating: 4.5,
  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "Razer Blade 15",
    specification: "15.6-inch, Intel i9, 32GB RAM, 1TB SSD",
    price: 18999,
    deliveryInDays: 6,
    url: "https://m.media-amazon.com/images/I/71K7P66CGnL._AC_UF1000,1000_QL80_.jpg",
    rating: 4.75,
  },
  {
    _id: uuid(),
    category: "Laptop",
    name: "LG Gram 17",
    specification: "17-inch, Intel i7, 16GB RAM, 1TB SSD",
    price: 15999,
    deliveryInDays: 5,
    url: "https://images-cdn.ubuy.co.in/633ac84e72530c0030291006-lg-gram-17z90p-laptop-17-quot-ips.jpg",
    rating: 3.75,
  },
  // Phones
  {
    _id: uuid(),
    category: "Phone",
    name: "iPhone 13 Pro",
    specification: "6.1-inch Super Retina XDR, Apple A15 Bionic, 128GB",
    price: 1099,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/619m8rLBQSL.jpg",
    rating: 5,
    brand:"iOS"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Samsung Galaxy S21",
    specification: "6.2-inch Dynamic AMOLED, Snapdragon 888, 256GB",
    price: 899,
    deliveryInDays: 4,
    url: "https://m.media-amazon.com/images/I/614n6dbzqtL._AC_UF894,1000_QL80_.jpg",
    rating: 5,
    brand:"Android"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Google Pixel 6",
    specification: "6.4-inch OLED, Google Tensor, 128GB",
    price: 799,
    deliveryInDays: 5,
    url: "https://m.media-amazon.com/images/I/61ruKkvVIxL.jpg",
    rating: 3.75,
    brand:"Android"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "OnePlus 9 Pro",
    specification: "6.7-inch Fluid AMOLED, Snapdragon 888, 256GB",
    price: 999,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/614cCf6bzyL.jpg",
    rating: 3.75,
    brand:"Android"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Xiaomi Mi 11",
    specification: "6.81-inch AMOLED, Snapdragon 888, 128GB",
    price: 799,
    deliveryInDays: 4,
    url: "https://m.media-amazon.com/images/I/71XmlboxNZL._SX679_.jpg",
    rating: 3,
    brand:"Android"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Sony Xperia 1 III",
    specification: "6.5-inch OLED, Snapdragon 888, 256GB",
    price: 1299,
    deliveryInDays: 5,
    url: "https://ovantica.com/pub/media/catalog/product/cache/359e51c8e354c4e2b5af98e814f93978/s/o/sony_xperia1-ii-purple-128-gb.png",
    rating: 3.75,
    brand:"Android"

  },
  {
    _id: uuid(),
    category: "Phone",
    name: "LG Velvet",
    specification: "6.8-inch OLED, Snapdragon 765, 128GB",
    price: 599,
    deliveryInDays: 3,
    url: "https://ovantica.com/pub/media/catalog/product/cache/359e51c8e354c4e2b5af98e814f93978/l/g/lg_velvet_4g_launched_with_snapd-1.png",
    rating: 3.75,
  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Motorola Edge+",
    specification: "6.7-inch OLED, Snapdragon 865, 256GB",
    price: 899,
    deliveryInDays: 4,
    url: "https://www.reliancedigital.in/medias/Motorola-EDGE-30-Mobile-Phone-492912754-i-2-1200Wx1200H?context=bWFzdGVyfGltYWdlc3w0NjQ4NnxpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDcyLzk4MzE2ODY4NjQ5MjYuanBnfDdhYmUyZDEzYjRiOWY0MTI3OWJhYzllZTU4YzZiOTU2ZjlkYzk1M2E5ZDNiOTVkZWJlMDkzY2MxZDhlNWYyYzc",
    rating: 4.75,
  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Nokia 8.3",
    specification: "6.81-inch IPS LCD, Snapdragon 765G, 128GB",
    price: 499,
    deliveryInDays: 5,
    url: "https://m.media-amazon.com/images/I/71D6aannQlL.jpg",
    rating: 3.5,
  },
  {
    _id: uuid(),
    category: "Phone",
    name: "Realme GT",
    specification: "6.43-inch Super AMOLED, Snapdragon 888, 128GB",
    price: 499,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/41wvVFEYCiL._SX300_SY300_QL70_FMwebp_.jpg",
    rating: 4,
  },
  // Headphones
  {
    _id: uuid(),
    category: "Headphones",
    name: "Sony WH-1000XM4",
    specification: "Wireless Over-Ear Headphones",
    price: 349,
    deliveryInDays: 2,
    url: "https://m.media-amazon.com/images/I/51SKmu2G9FL._AC_UF1000,1000_QL80_.jpg",
    rating: 5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Bose QuietComfort 35 II",
    specification: "Wireless Over-Ear Headphones",
    price: 299,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/71Aclgd057L._AC_UF1000,1000_QL80_.jpg",
    rating: 4.5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Sennheiser HD 660 S",
    specification: "Open-Back Over-Ear Headphones",
    price: 499,
    deliveryInDays: 4,
    url: "https://m.media-amazon.com/images/I/71kC1BXo9PL._AC_UF1000,1000_QL80_.jpg",
    rating: 5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Jabra Elite 85t",
    specification: "Wireless Earbuds",
    price: 229,
    deliveryInDays: 2,
    url: "https://m.media-amazon.com/images/I/71-3C3aYveL.jpg",
    rating: 4.5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Apple AirPods Pro",
    specification: "Wireless Earbuds",
    price: 249,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/71tbMyhmxcL._AC_UF1000,1000_QL80_.jpg",
    rating: 4,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Beats Solo Pro",
    specification: "Wireless On-Ear Headphones",
    price: 199,
    deliveryInDays: 4,
    url: "https://m.media-amazon.com/images/I/61BOKa62IqL._AC_UF1000,1000_QL80_.jpg",
    rating: 3.5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Bose SoundSport Free",
    specification: "True Wireless Earbuds",
    price: 179,
    deliveryInDays: 2,
    url: "https://m.media-amazon.com/images/I/71N4RsWobbS.jpg",
    rating: 4.5,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "JBL Quantum 800",
    specification: "Wireless Gaming Headset",
    price: 149,
    deliveryInDays: 3,
    url: "https://m.media-amazon.com/images/I/712zz31jpaL._AC_UF1000,1000_QL80_.jpg",
    rating: 3,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "SteelSeries Arctis 7",
    specification: "Wireless Gaming Headset",
    price: 149,
    deliveryInDays: 4,
    url: "https://m.media-amazon.com/images/I/81pCpKFjBZL._AC_UF1000,1000_QL80_.jpg",
    rating: 3,
  },
  {
    _id: uuid(),
    category: "Headphones",
    name: "Anker Soundcore Liberty Air 2 Pro",
    specification: "Wireless Earbuds",
    price: 99.99,
    deliveryInDays: 2,
    url: "https://m.media-amazon.com/images/I/61a3VAbtpQL._AC_UF1000,1000_QL80_.jpg",
    rating: 2.5,
  },
  // ... (additional laptops, phones, and headphones)
];
